import {isNullOrUndefined} from "../../../services/Validator";

export default function BrevetLevelATaskText({text}) {
    // Used in BrevetLevelAsItem

    // BUILD
    if (isNullOrUndefined(text))
        return null
    return (
        <div className={"font-bold text-[14px] text-white"}>
            {text}
        </div>
    );
}